export default {"src":"__ASTRO_ASSET_IMAGE__ZyS7L4jp__","width":144,"height":144,"format":"png"}